module.exports = __webpack_public_path__ + "img/asset15.3e308f86.png";